import { useEffect } from "react";

// Setează titlul tabului în funcție de pagina curentă.
export default function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} · iCode CRM` : "iCode CRM";
  }, [title]);
}
